(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3900,648,5637,1868,4346,682,1803],{

/***/ 1868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4012);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2965);
/* harmony import */ var _CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var src_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38);
/* harmony import */ var _public_logo_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3476);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4215);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1555);
/* harmony import */ var _assets_images_second_bg_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5893);










var AccordionComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return __webpack_require__.e(/* import() */ 4113).then(__webpack_require__.bind(__webpack_require__, 4113));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4113)];
    }
  }
});




var CommonQuestions = function CommonQuestions(_ref) {
  var commonQuestionsBackgroundImage = _ref.commonQuestionsBackgroundImage,
      filteredQuestions = _ref.filteredQuestions;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(),
      locale = _useRouter.locale;

  var isRtl = locale === "ar";
  var dir = isRtl ? "rtl" : "ltr";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("section", {
    className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().questions),
    style: {
      backgroundImage: "url(".concat(_assets_images_second_bg_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"].src */ .Z.src, ")")
    },
    dir: dir,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__["default"], {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h2", {
        className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().customHead),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          id: "popular-questions"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["common-questions"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__["default"], {
          className: "gy-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
            xs: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().accordion),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(AccordionComponent, {
                data: filteredQuestions
              })
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CommonQuestions);

/***/ }),

/***/ 4346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/components/shared/breadCrumb/styles/styles.module.scss
var styles_module = __webpack_require__(6962);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/breadCrumb.avif
/* harmony default export */ var breadCrumb = ({"src":"/_next/static/media/breadCrumb.aff9d432.avif","height":1330,"width":2000,"blurDataURL":"data:image/avif;base64,AAAAHGZ0eXBhdmlmAAAAAG1pZjFhdmlmbWlhZgAAAXBtZXRhAAAAAAAAACFoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAAAAAAA5waXRtAAAAAAABAAAANGlsb2MAAAAAREAAAgABAAAAAAGUAAEAAAAAAAAATwACAAAAAAHjAAEAAAAAAAAAFQAAADhpaW5mAAAAAAACAAAAFWluZmUCAAAAAAEAAGF2MDEAAAAAFWluZmUCAAAAAAIAAGF2MDEAAAAAr2lwcnAAAACKaXBjbwAAAAxhdjFDgSACAAAAABRpc3BlAAAAAAAAAAgAAAAFAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAcAAAAAA5waXhpAAAAAAEIAAAAOGF1eEMAAAAAdXJuOm1wZWc6bXBlZ0I6Y2ljcDpzeXN0ZW1zOmF1eGlsaWFyeTphbHBoYQAAAAAdaXBtYQAAAAAAAAACAAEDgQIDAAIEhAIFhgAAABppcmVmAAAAAAAAAA5hdXhsAAIAAQABAAAAbG1kYXQSAAoIOAi8YQENBpAyQRTAAABQqEVlZka/Msh/reC4VnUKNzTWMxH5mLGkhcrFORQnQ2II1O05fqzWbykXkMdGLA/rXmxorUD2MsXhlSGAEgAKBRgIvGFQMgoUwAABAAF1UKUo","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/works_breadcrumb.jpg
/* harmony default export */ var works_breadcrumb = ({"src":"/_next/static/media/works_breadcrumb.537d82bb.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAYEAEAAwEAAAAAAAAAAAAAAAAAAQIzcf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAIxAf/aAAwDAQACEQMRAD8AhYwtwA7UnWYf/9k=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/assets/servics_breadcrumb.jpg
/* harmony default export */ var servics_breadcrumb = ({"src":"/_next/static/media/servics_breadcrumb.406428d8.jpg","height":200,"width":1700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAZEAEAAgMAAAAAAAAAAAAAAAAAAgMzcsL/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AIivNHToAkHX/9k=","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/shared/breadCrumb/Index.js












var BreadCrumb = function BreadCrumb(_ref) {
  var title = _ref.title;
  var router = (0,next_router.useRouter)();
  var locale = router.locale;
  var isRtl = locale === "ar";
  var isServicesPage = router.pathname === "/services";
  var isWorksPage = router.pathname === "/ourworks" || router.pathname === "/blogs" || router.pathname === "/blogs/[slug]";
  var backgroundImage = isServicesPage ? servics_breadcrumb : isWorksPage ? works_breadcrumb : breadCrumb;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (styles_module_default()).breads,
    dir: locale === "ar" ? "rtl" : "ltr",
    style: {
      backgroundImage: "url(".concat(backgroundImage.src || backgroundImage, ")")
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).breads__inner,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (styles_module_default()).breads__content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/contactus",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (styles_module_default())["cta-button-red"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "contact-us"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["icon-circle"],
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  style: {
                    transform: isRtl ? "none" : "scaleX(-1)"
                  },
                  width: "18",
                  height: "18",
                  viewBox: "0 0 18 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53577 3.53556L14.1424 14.1422",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                    stroke: "black",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  })]
                })
              })]
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Index = (BreadCrumb);

/***/ }),

/***/ 38:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f8": function() { return /* binding */ buildApiUrl; }
/* harmony export */ });
/* unused harmony exports getImageUrl, validateImageUrl, getImageDimensions */
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var buildApiUrl = function buildApiUrl(path) {
  if (!path) return "";

  try {
    new URL(path);
    return path;
  } catch (_unused) {
    var base = "https://mu7.ejjadh.info" || 0;
    var sep = path.startsWith("/") ? "" : "/";
    return "".concat(base).concat(sep).concat(path);
  }
}; // Helper function to ensure valid image URLs and proper error handling

var getImageUrl = function getImageUrl(path) {
  if (!path) return null;

  try {
    // If it's already a full URL, return it
    new URL(path);
    return path;
  } catch (_unused2) {
    // If it's a relative path, prepend the API URL
    return buildApiUrl(path);
  }
}; // Helper function to validate image

var validateImageUrl = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url, {
              method: "HEAD"
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.ok);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function validateImageUrl(_x) {
    return _ref.apply(this, arguments);
  };
}())); // Helper function to get proper image dimensions

var getImageDimensions = function getImageDimensions() {
  var imageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var dimensions = {
    "default": {
      width: 800,
      height: 600
    },
    thumbnail: {
      width: 150,
      height: 150
    },
    banner: {
      width: 1920,
      height: 1080
    },
    profile: {
      width: 300,
      height: 300
    }
  };
  return dimensions[imageType] || dimensions["default"];
};

/***/ }),

/***/ 3900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContactUsPage_ContactUsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/modules/ContactUsPage/ContactUsPage.module.scss
var ContactUsPage_module = __webpack_require__(6516);
var ContactUsPage_module_default = /*#__PURE__*/__webpack_require__.n(ContactUsPage_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/ContacUsPage/Map/Map.jsx


var ContactMap = function ContactMap(_ref) {
  var _data$AppSetting;

  var data = _ref.data;
  var mapHTML = (data === null || data === void 0 ? void 0 : (_data$AppSetting = data.AppSetting) === null || _data$AppSetting === void 0 ? void 0 : _data$AppSetting.ifameMap) || "";
  var updatedHTML = mapHTML.includes("title=") ? mapHTML : mapHTML.replace("<iframe", "<iframe title='Map'");
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    dangerouslySetInnerHTML: {
      __html: updatedHTML
    }
  });
};

/* harmony default export */ var Map = (ContactMap);
;// CONCATENATED MODULE: ./src/assets/images/mingcute_location-fill.png
/* harmony default export */ var mingcute_location_fill = ({"src":"/_next/static/media/mingcute_location-fill.99c4c9c4.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEW6AADSAACuAACTAAC+AACVAAC0AABMaXHUAACsAADQAAC3AACPAACJAADlAACcAADkAADgAACrAADNAACRAAC+AADJAADkAACpAADAAADsAADhAACmAABcPZmfAAAAG3RSTlMRaf7m/mo6AAEC/EjRJdL5JvDK2LPK/beDggdjW7qsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVR4nBXLRxLAIAwDQAEG2ZDeM+b/78xk7wslWgMVXPYqaSR4+7nFg8BagTkBNvn79EHB4Jf0TCiDxPwvYyk0fl31AopMJ0eaAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/trending_down.png
/* harmony default export */ var trending_down = ({"src":"/_next/static/media/trending_down.6b0d1d0a.png","height":21,"width":21,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEVMaXGTAADJAAC+AADDAADDAADcAAC+AACbAADHAAC8AADOAADhAACsAACJAADiAADjAACiAADTAABUC6sNAAAAEHRSTlMAafL+mi+vRwsiZN7H4o2Z1akpgAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADZJREFUeJwtykkKACAMQ9HUqdaxev/DCsGsHp8A1hO44sGIcVsltmdQ6v+DElWYcohHmHSehQcmzAEZVgyTSwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/ic_round-email.png
/* harmony default export */ var ic_round_email = ({"src":"/_next/static/media/ic_round-email.b6a17490.png","height":22,"width":22,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEVMaXGnAADNAACEAACYAADmAADnAACHAADOAACUAADWAACoAAC3AADnAADnAADCAADnAADHAACvAAC5AACxAADNAACfAADdAADBAACVAADvAAChAACZxArxAAAAF3RSTlMAiP4jgTUQX32wpf6sNkLhwJjZa2y7uU2YNU8AAAAJcEhZcwAACxMAAAsTAQCanBgAAABASURBVHicY2CAAWZOMR4eUS42BnZOTgkmQQE+BnZJRhFhLnFWBnZJbiF+cRBDmluCSVyKl4GZhYWRg4ODDa4bAFdsAl66Hq7eAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/Group.png
/* harmony default export */ var Group = ({"src":"/_next/static/media/Group.207dccae.png","height":22,"width":20,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAVFBMVEWxAAC1AACVAADTAADkAACsAADYAADGAAC+AACzAACPAACSAADmAACrAAC2AADkAADYAACpAADSAADEAAC0AACLAACmAACvAACeAACmAADKAADZAABfC98qAAAAGHRSTlMCKZv+/vqb/fxJ5mXt57Hea9Rh4af63DXtlB/PAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nAXBhxHAMAgAsXcF7PR2ONl/z0hwnPp02LJcZXTWT614Iyex3W+m9C7mjZpF5xGhipYIECzAD1HyAih1APvaAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4215);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/components/shared/CommonQuestions/CommonQuestions.jsx
var CommonQuestions = __webpack_require__(1868);
// EXTERNAL MODULE: ./src/components/shared/breadCrumb/Index.js + 3 modules
var Index = __webpack_require__(4346);
;// CONCATENATED MODULE: ./src/modules/ContactUsPage/ContactUsPage.jsx






var Footer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(7148), __webpack_require__.e(6892)]).then(__webpack_require__.bind(__webpack_require__, 7148));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7148)];
    }
  }
});
var InfoWithIcon = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 797).then(__webpack_require__.bind(__webpack_require__, 797));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(797)];
    }
  }
});
var Form = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(7536), __webpack_require__.e(4829)]).then(__webpack_require__.bind(__webpack_require__, 4829));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4829)];
    }
  }
});
var PageHeader = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(9477), __webpack_require__.e(4208), __webpack_require__.e(1845)]).then(__webpack_require__.bind(__webpack_require__, 2094));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2094)];
    }
  }
});












var ContactUsPage = function ContactUsPage(_ref) {
  var _data$questions, _data$questions$, _data$questions$$cate, _data$questions$$cate2, _targetQuestion$data, _footer$AppSetting, _footer$AppSetting2, _footer$socials, _footer$socials2, _footer$socials3, _footer$socials3$phon, _footer$socials4, _footer$socials5, _footer$socials6, _footer$AppSetting3;

  var data = _ref.data,
      footerData = _ref.footerData;
  var router = (0,next_router.useRouter)();
  var lang = router.locale;
  var footer = footerData || {};
  var questionsData = data === null || data === void 0 ? void 0 : (_data$questions = data.questions) === null || _data$questions === void 0 ? void 0 : (_data$questions$ = _data$questions[0]) === null || _data$questions$ === void 0 ? void 0 : (_data$questions$$cate = _data$questions$.categories) === null || _data$questions$$cate === void 0 ? void 0 : (_data$questions$$cate2 = _data$questions$$cate[0]) === null || _data$questions$$cate2 === void 0 ? void 0 : _data$questions$$cate2.posts;
  var targetQuestion = questionsData === null || questionsData === void 0 ? void 0 : questionsData.find(function (question) {
    return question.id === 608;
  });
  var commonQuestionsBackgroundImage = targetQuestion === null || targetQuestion === void 0 ? void 0 : (_targetQuestion$data = targetQuestion.data) === null || _targetQuestion$data === void 0 ? void 0 : _targetQuestion$data.image;
  var filteredQuestions = questionsData === null || questionsData === void 0 ? void 0 : questionsData.filter(function (question) {
    return question.id !== 608;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Index["default"], {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "contact-us"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ContactUsPage_module_default()).background,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container["default"], {
        children: [(footer === null || footer === void 0 ? void 0 : (_footer$AppSetting = footer.AppSetting) === null || _footer$AppSetting === void 0 ? void 0 : _footer$AppSetting.ifameMap) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ContactUsPage_module_default())["contact-map"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Map, {
            data: footer
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ContactUsPage_module_default()).form,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row["default"], {
            className: "".concat((ContactUsPage_module_default())["contact-row"], " ").concat(!(footer !== null && footer !== void 0 && (_footer$AppSetting2 = footer.AppSetting) !== null && _footer$AppSetting2 !== void 0 && _footer$AppSetting2.ifameMap) ? (ContactUsPage_module_default())["contact-row-no-map"] : ""),
            dir: lang === "ar" ? "rtl" : "ltr",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col["default"], {
              lg: 8,
              xs: 12,
              className: (ContactUsPage_module_default())["form-col"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Form, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col["default"], {
              lg: 4,
              xs: 12,
              className: (ContactUsPage_module_default())["info-col"],
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (ContactUsPage_module_default())["info-list"],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (ContactUsPage_module_default())["info-item"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoWithIcon, {
                    svgIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: mingcute_location_fill,
                      alt: "location",
                      width: 20,
                      height: 20
                    }),
                    primaryText: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "location"
                    }),
                    secondaryText: lang === "ar" ? footer === null || footer === void 0 ? void 0 : (_footer$socials = footer.socials) === null || _footer$socials === void 0 ? void 0 : _footer$socials.address : footer === null || footer === void 0 ? void 0 : (_footer$socials2 = footer.socials) === null || _footer$socials2 === void 0 ? void 0 : _footer$socials2.address_EN
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((ContactUsPage_module_default())["info-item"], " ").concat((ContactUsPage_module_default())["info-item-light"]),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: (ContactUsPage_module_default())["info-link"],
                    href: "tel:".concat(footer === null || footer === void 0 ? void 0 : (_footer$socials3 = footer.socials) === null || _footer$socials3 === void 0 ? void 0 : (_footer$socials3$phon = _footer$socials3.phone) === null || _footer$socials3$phon === void 0 ? void 0 : _footer$socials3$phon.split(" ").join("")),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoWithIcon, {
                      svgIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        src: trending_down,
                        alt: "phone",
                        width: 20,
                        height: 20
                      }),
                      primaryText: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "phone"
                      }),
                      secondaryText: footer === null || footer === void 0 ? void 0 : (_footer$socials4 = footer.socials) === null || _footer$socials4 === void 0 ? void 0 : _footer$socials4.phone
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (ContactUsPage_module_default())["info-item"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: (ContactUsPage_module_default())["info-link"],
                    href: "mailto:".concat(footer === null || footer === void 0 ? void 0 : (_footer$socials5 = footer.socials) === null || _footer$socials5 === void 0 ? void 0 : _footer$socials5.email),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoWithIcon, {
                      svgIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        src: ic_round_email,
                        alt: "email",
                        width: 20,
                        height: 20
                      }),
                      primaryText: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "mail"
                      }),
                      secondaryText: footer === null || footer === void 0 ? void 0 : (_footer$socials6 = footer.socials) === null || _footer$socials6 === void 0 ? void 0 : _footer$socials6.email
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((ContactUsPage_module_default())["info-item"], " ").concat((ContactUsPage_module_default())["info-item-light"]),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoWithIcon, {
                    svgIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: Group,
                      alt: "work-time",
                      width: 20,
                      height: 20
                    }),
                    primaryText: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "work_time"
                    }),
                    secondaryText: footer === null || footer === void 0 ? void 0 : (_footer$AppSetting3 = footer.AppSetting) === null || _footer$AppSetting3 === void 0 ? void 0 : _footer$AppSetting3.work_time
                  })
                })]
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CommonQuestions["default"], {
      commonQuestionsBackgroundImage: commonQuestionsBackgroundImage,
      filteredQuestions: filteredQuestions
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
};

/* harmony default export */ var ContactUsPage_ContactUsPage = (ContactUsPage);

/***/ }),

/***/ 3476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo.72f176e4.png","height":3264,"width":5016,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAANlBMVEUBAAALAAD3AAALDhALGCAFCw4OGSABAAAOFx4AAADdAQIPFx6xBQjxAAAOGSIRFSIAFxcAGyS2XswHAAAAEnRSTlM7K1sySyGvJ4E4fVJZJp08C3gWJ2qoAAAACXBIWXMAAEzlAABM5QF1zvCVAAAALElEQVR4nAXBhwEAEBAAscNX3f7LSogRcUevbDNrb3ZEj4TUhTdX96IkCUn5HKQBEo69UrAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/second-bg.d53eab00.png","height":523,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEXe3t7k5OTi4uLo6Oji4uKEqJd8AAAABXRSTlM5Y1NwR+60uYcAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAXSURBVHicY2BgYmBiACFmRmZGRkYmZgAAqAAWu9UqAAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 2965:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"questions":"CommonQuestions_questions__ilkFQ","customHead":"CommonQuestions_customHead__cjF8U","common-questions":"CommonQuestions_common-questions__5obFp","background-image":"CommonQuestions_background-image__fAeTz","overlay-text":"CommonQuestions_overlay-text___OSqI","cta-button-red":"CommonQuestions_cta-button-red__wtYiF","icon-circle":"CommonQuestions_icon-circle__9e8xI","accordion":"CommonQuestions_accordion__1qFeG","BlueHoleIcon":"CommonQuestions_BlueHoleIcon___wAeX"};

/***/ }),

/***/ 6962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breads":"styles_breads__eY1Zd","breads__inner":"styles_breads__inner__WYN36","breads__content":"styles_breads__content__i7wfq","cta-button-red":"styles_cta-button-red__Oa5fB","icon-circle":"styles_icon-circle__VDLuX"};

/***/ }),

/***/ 6516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"ContactUsPage_background__WhwSk","box":"ContactUsPage_box__JAoSB","flex-col":"ContactUsPage_flex-col__8IIPO","element":"ContactUsPage_element__OhCca","form":"ContactUsPage_form__6elLf","contact-row":"ContactUsPage_contact-row__5Dd56","contact-row-no-map":"ContactUsPage_contact-row-no-map__yCXor","form-col":"ContactUsPage_form-col__ymKsN","info-col":"ContactUsPage_info-col__obALr","info-list":"ContactUsPage_info-list__rYiXk","info-item":"ContactUsPage_info-item__ayMvd","info-item-light":"ContactUsPage_info-item-light__kkCDR","info-link":"ContactUsPage_info-link__o_NvU","phone":"ContactUsPage_phone__gAa1V","contact-map":"ContactUsPage_contact-map__QKcPw"};

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useCol": function() { return /* binding */ useCol; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["default"] = (Col);

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ }),

/***/ 4215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["default"] = (Row);

/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 6896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ })

}]);